import { render, staticRenderFns } from "./setAccount.vue?vue&type=template&id=4216dcbc&scoped=true"
import script from "./setAccount.vue?vue&type=script&lang=js"
export * from "./setAccount.vue?vue&type=script&lang=js"
import style0 from "./setAccount.vue?vue&type=style&index=0&id=4216dcbc&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4216dcbc",
  null
  
)

export default component.exports